export default "/images/23de2ac16ea575e6c545e51fbe3782dc.jpg";